import { render, staticRenderFns } from "./NAsyncSingleSelect.vue?vue&type=template&id=5945a724&"
import script from "./NAsyncSingleSelect.vue?vue&type=script&lang=js&"
export * from "./NAsyncSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./NAsyncSingleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports